import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Minus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartItem = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: 100 }}
      className="bg-orange-50 rounded-2xl p-4 border border-orange-200"
      data-testid={`cart-item-${item.id}`}
    >
      <div className="flex gap-4">
        <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-xl" />
        <div className="flex-1">
          <h3 className="font-bold text-violet-700 mb-1" data-testid={`cart-item-name-${item.id}`}>{item.name}</h3>
          <p className="text-orange-600 font-bold" data-testid={`cart-item-price-${item.id}`}>${item.price.toFixed(2)} each</p>
          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={() => updateQuantity(item.id, item.quantity - 1)}
              className="bg-white border-2 border-orange-300 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center hover:bg-orange-100 transition-colors"
              data-testid={`decrease-quantity-${item.id}`}
            >
              <Minus size={16} />
            </button>
            <span className="font-bold text-lg w-8 text-center" data-testid={`cart-item-quantity-${item.id}`}>{item.quantity}</span>
            <button
              onClick={() => updateQuantity(item.id, item.quantity + 1)}
              className="bg-white border-2 border-orange-300 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center hover:bg-orange-100 transition-colors"
              data-testid={`increase-quantity-${item.id}`}
            >
              <Plus size={16} />
            </button>
            <button
              onClick={() => removeFromCart(item.id)}
              className="ml-auto text-red-500 hover:text-red-700 transition-colors"
              data-testid={`remove-item-${item.id}`}
            >
              <Trash2 size={20} />
            </button>
          </div>
        </div>
      </div>
      <div className="mt-2 text-right">
        <span className="text-sm text-gray-600">Subtotal: </span>
        <span className="font-bold text-violet-700" data-testid={`cart-item-subtotal-${item.id}`}>
          ${(item.price * item.quantity).toFixed(2)}
        </span>
      </div>
    </motion.div>
  );
};

export default CartItem;
